import { alpha } from "@mui/material/styles";

/** Empty-hole tint opacity — shared by reference overlay and play board hole. */
export const SLIDING_EMPTY_SLOT_OPACITY = 0.85;

/** Semi-transparent gray fill (use as `backgroundColor`, not `bgcolor` + `opacity`). */
export function slidingEmptySlotBackground(theme, opacity = SLIDING_EMPTY_SLOT_OPACITY) {
    return alpha(theme.palette.grey[500], opacity);
}
